import cls from "classnames";
import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import MediaViewer from "./mediaViewer";
import * as Track from "@qoohoo/common/utils/analytics/track";

import "swiper/css";
import "swiper/css/navigation";
import { button, pageview } from "@qoohoo/common/constants/analytics";

const Carousel = ({ channelDetails, isInCourse }) => {
  const [swiperRef, setSwiperRef] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const trackDetails = {
    current_screen: pageview.channel_details,
    url: `/by/${channelDetails.creator.username}`,
    uid: channelDetails.uid,
    name: channelDetails.name,
    "creator.uid": channelDetails.creator.uid,
    "creator.full_name": channelDetails.creator.fullname,
    "creator.username": channelDetails.creator.username,
    is_verified_creator: channelDetails.creator.is_verified_creator,
    total_intro_media: channelDetails.medias.length,
    current_slide: currentSlide,
  };
  const showWatermark = channelDetails.enable_watermark;

  return (
    <div className={cls(isInCourse ? "h-full" : "")}>
      {channelDetails.medias.length > 0 && channelDetails.medias[0].url ? (
        <Swiper
          onSwiper={setSwiperRef}
          modules={[Navigation]}
          centeredSlides={true}
          pagination={{ clickable: true }}
          allowTouchMove={false}
          navigation={{
            prevEl: swiperRef?.navigation.$prevEl[0]?.current,
            nextEl: swiperRef?.navigation.$nextEl[0]?.current,
          }}
          onSlideChange={(swiper) => {
            setCurrentSlide(swiper.activeIndex);
          }}
          spaceBetween={2}
          className="custom-carousel"
          style={{
            position: "unset",
            width: "100% !important",
            height: isInCourse ? "100%" : "auto",
          }}
        >
          {channelDetails.medias.map((asset) => {
            return (
              <SwiperSlide
                key={asset.uid}
                onClick={() => {
                  Track.buttonClick(button.click_intro_media, trackDetails);
                }}
              >
                <MediaViewer
                  url={asset.url}
                  currentSlide={currentSlide}
                  imageClassName="lg:w-[701px] h-[220px] sm:h-[370px]"
                  videoClassName="lg:children:!w-[701px] children:!h-[220px] sm:children:!h-[370px]"
                  channelName={trackDetails.name}
                  creatorName={trackDetails["creator.full_name"]}
                  showWatermark={showWatermark}
                />
              </SwiperSlide>
            );
          })}
          {channelDetails?.medias?.length > 1 && (
            <>
              <div
                className={cls(
                  "swiper-button-prev flex items-center absolute inset-0 cursor-pointer bg-[#373E43] rounded-full overflow-hidden !h-10 !w-10 select-none sm:-ml-1",
                  currentSlide === 0 && "!hidden"
                )}
                onClick={() => {
                  if (currentSlide !== 0) {
                    Track.buttonClick(button.prev_intro_media, {
                      ...trackDetails,
                      prev_slide: currentSlide - 1,
                    });
                  }
                  swiperRef?.slidePrev();
                }}
              >
                <img
                  src="/assets/icons/carousel-right.svg"
                  alt="previous slide button"
                  className="mr-1 rotate-180 sm:mr-0"
                />
              </div>
              <div
                className={cls(
                  "swiper-button-next flex items-center absolute inset-0 cursor-pointer bg-[#373E43] rounded-full !h-10 !w-10 select-none sm:-mr-1",
                  currentSlide === channelDetails.medias.length - 1 && "!hidden"
                )}
                onClick={() => {
                  if (currentSlide !== channelDetails.medias.length - 1) {
                    Track.buttonClick(button.next_intro_media, {
                      ...trackDetails,
                      next_slide: currentSlide + 1,
                    });
                  }
                  swiperRef?.slideNext();
                }}
              >
                <img
                  src="/assets/icons/carousel-right.svg"
                  alt="next slide button"
                  className="ml-1 sm:ml-0"
                />
              </div>
            </>
          )}
        </Swiper>
      ) : null}
    </div>
  );
};

export default Carousel;
